// import waypoints from node_modules
import 'waypoints/lib/jquery.waypoints';
import 'waypoints/lib/shortcuts/sticky';


jQuery(function($) {
    const navigationSticky = () => {
        if ($(window).width() > 993) {
            desktopMenu();
        }
        if ($(window).width() < 992) {
            MobileMenu();
        }
    }
    navigationSticky();

    $(window).resize(navigationSticky);
    //Menu for desktop
    function desktopMenu() {
        var sticky = new Waypoint.Sticky({
            element: $('.header-nav-desktop')
        })
    }

    //Menu for tablet and mobile
    function MobileMenu() {
        var sticky = new Waypoint.Sticky({
            element: $('.header'),
            handler: function(direction) {
                $('.header-nav-mobile').toggleClass('stuck');
            }, 
        })
    }
});
  